import { create } from 'zustand';
import type { AuthChangeEvent, Session, User } from '@supabase/supabase-js';
import type { Database } from '@/lib/supabase/types';

type ProfileRow = Database['public']['Tables']['profiles']['Row'];

type AuthState = {
  session: Session | null;
  user: User | null;
  loaded: boolean;
  authEvent: AuthChangeEvent | null;
  profile: ProfileRow | null;
  profileLoaded: boolean;
  setSession: (session: Session | null) => void;
  setLoaded: (loaded: boolean) => void;
  setAuthEvent: (event: AuthChangeEvent) => void;
  setProfile: (profile: ProfileRow | null) => void;
  setProfileLoaded: (loaded: boolean) => void;
};

export const useAuthStore = create<AuthState>((set) => ({
  session: null,
  user: null,
  loaded: false,
  authEvent: null,
  profile: null,
  profileLoaded: false,
  setSession: (session) => set({ session, user: session?.user ?? null }),
  setLoaded: (loaded) => set({ loaded }),
  setAuthEvent: (authEvent) => set({ authEvent }),
  setProfile: (profile) => set({ profile }),
  setProfileLoaded: (profileLoaded) => set({ profileLoaded }),
}));
